import ErrorBoundary from "components/ErrorBoundary";
import React, { useEffect } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Col,
  Nav,
  Row,
} from "reactstrap";
import CTooltip from "react-tooltip-lite";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  ArcElement,
} from "chart.js";
import { Line } from "react-chartjs-2";
import DownloadCSVButton from "./DownloadCsv";
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  ArcElement
);

ChartJS.register(ArcElement, Tooltip, Legend);

const plugin = {
  beforeInit(chart) {
    // Get reference to the original fit function
    const originalFit = chart.legend.fit;

    // Override the fit function
    chart.legend.fit = function fit() {
      // Call original function and bind scope in order to use `this` correctly inside it
      originalFit.bind(chart.legend)();
      // Change the height as suggested in another answers
      this.height = this.height + 15;
    };
  },
};

export const options = {
  responsive: true,
  maintainAspectRatio: false,
  scales: {
    // x: {
    //   title: {
    //     display: true,
    //     text: "Time (months)",
    //   },
    // },
    // y: {
    //   title: {
    //     display: true,
    //     text: "Sales (units)",
    //   },
    // },
  },


  plugins: {
    legend: {
      position: "top",
      labels: {
        padding: 15,
        usePointStyle: true,
        pointStyle: "rect",
        color: "#707070",
        font: {
          size: 14,
          weight: "600",
        },
      },
      align: "start",
    },
    tooltip: {
      callbacks: {
        // mode: 'nearest',
        intersect: false,
      },
    },
  },
};

const FaxOverview = (props) => {
  const { months, inboundFaxCount, outboundFailedFaxCount, outboundFaxCount, unmappedFaxCount } = props;
  const copyData = {
    labels: months,
    datasets:
      [
        {
          label: "Unmapped Fax Count",
          data: unmappedFaxCount,
          borderColor: "#12545E",
          backgroundColor: "#12545E",
          pointRadius: 3.5,
        },
        {
          label: "Outbound Fax Count",
          data: outboundFaxCount,
          borderColor: "#702C62",
          backgroundColor: "#702C62",
          pointRadius: 3.5,
        },
        {
          label: "Outbound Failed Fax Count",
          data: outboundFailedFaxCount,
          borderColor: "#3c702cff",
          backgroundColor: "#3c702cff",
          pointRadius: 3.5,
        },
        {
          label: "Inbound Fax Count",
          data: inboundFaxCount,
          borderColor: "#3C363B",
          backgroundColor: "#3C363B",
          pointRadius: 3.5,
        },

      ]
    ,
  };



  return (
    <div>
      <ErrorBoundary>
        <Card className="p-3 h-100 border-0 shadow-top">
          <CardHeader
            className="border-0 bg-white px-0 pt-0"
            style={{ paddingBottom: "0px" }}
          >
            <Row className="align-items-center">
              <Col>
                <CTooltip
                  content={
                    <div className="tip-list-info">
                      <p>
                        Displays counts of successful inbound mapped faxes, inbound unmapped faxes, successful outbound faxes, and failed outbound faxes.
                      </p>
                    </div>
                  }
                >

                  <CardTitle className="f-20 font-weight-600 dashboard-headings">
                    <div className="d-flex justify-content-between align-items-center top_left_hed pb-1 graph-headings">
                      Fax Overview
                      <DownloadCSVButton
                        monthsdata={months}
                        valuedata4={inboundFaxCount}
                        valuedata3={outboundFailedFaxCount}
                        valuedata2={outboundFaxCount}
                        valuedata1={unmappedFaxCount}
                        heading1={["Month", "Unmapped Fax Count", "Outbound Fax Count", "Outbound Failed Fax Count", "Inbound Fax Count"]}
                        filenamedata={"Fax Overview"}
                      />
                      {/* <img src={Download} /> */}
                    </div>
                  </CardTitle>
                </CTooltip>

              </Col>
              <Col xs="auto">
                <Nav className="widget-tabs"></Nav>
              </Col>
            </Row>
          </CardHeader>
          <CardBody className="dashboard-chart-body p-0">
            <div className="chat-container">
              <Line options={options} data={copyData} plugins={[plugin]} />
            </div>
          </CardBody>
        </Card>
      </ErrorBoundary>
    </div>
  );
};

export default FaxOverview;
